export default "__VITE_ASSET__CPR09i4x__"